import {defineToolRegistryManifest} from '../../types/base-tool-types';
import {z} from 'zod';
import dedent from 'dedent';
import {variableCssSchema} from '../../schemas';

const toolName = 'render-variables' as const;

const argumentZod = z.object({
  css: variableCssSchema,
});

export const renderVariablesTool = defineToolRegistryManifest({
  id: toolName,
  prettyName: 'Render variables',
  prettyStatus: {
    executing: 'Rendering variables...',
    executed: 'Rendered variables',
    failed: 'Failed to render variables',
  },
  prettyErrors: {
    fallback: 'Unable to render variables. Please try again.',
    patterns: [
      {
        match: 'gradient',
        message:
          'Color variables only support solid values (hex, rgb, hsl). Gradients are not supported.',
      },
      {
        match: 'font stack',
        message:
          "Font family variables accept a single font name only (e.g. 'Inter'). Font stacks are not supported.",
      },
    ],
  },
  llmTool: {
    name: toolName,
    description: dedent`
      Creates or updates CSS variables with collection and mode support in Webflow. Use for reusable design patterns and theming. Collections and modes are auto-created if they don't exist.
    `,
    inputSchema: argumentZod,
  },
  type: 'designer',
  permission: [{resource: 'SiteVariable', action: 'manage'}],
  confirmBeforeExecuting: true,
  timeout: 60000,
});
